
import { supabase } from '@/lib/supabase';
import type { CTraderAccount } from '@/components/accounts/ctrader-card/types';

export const ctraderProfileService = {
  async disconnectProfile(id: string): Promise<void> {
    // Get related records
    const { data: cspAccount, error: fetchError } = await supabase
      .from('csp_accounts')
      .select('id')
      .eq('id', id)
      .single();

    if (fetchError) throw fetchError;

    const { data: apiConnections, error: apiError } = await supabase
      .from('api_connections')
      .select('id')
      .eq('csp_account_id', id);

    if (apiError) throw apiError;

    const apiConnectionIds = apiConnections?.map(conn => conn.id) || [];

    // Execute disconnect transaction
    const { error: updateError } = await supabase.rpc('disconnect_ctrader_profile', {
      csp_account_id: id,
      api_connection_ids: apiConnectionIds
    });

    if (updateError) throw updateError;
  },

  async reconnectProfile(id: string): Promise<void> {
    // Get related records
    const { data: cspAccount, error: fetchError } = await supabase
      .from('csp_accounts')
      .select('id')
      .eq('id', id)
      .single();

    if (fetchError) throw fetchError;

    const { data: apiConnections, error: apiError } = await supabase
      .from('api_connections')
      .select('id')
      .eq('csp_account_id', id);

    if (apiError) throw apiError;

    const apiConnectionIds = apiConnections?.map(conn => conn.id) || [];

    // Execute reconnect transaction
    const { error: updateError } = await supabase.rpc('reconnect_ctrader_profile', {
      csp_account_id: id,
      api_connection_ids: apiConnectionIds
    });

    if (updateError) throw updateError;
  },

  async deleteProfile(id: string): Promise<void> {
    const { error } = await supabase
      .from('csp_accounts')
      .delete()
      .eq('id', id);

    if (error) throw error;
  }
};

